module.exports = __webpack_public_path__ + "img/LandCoverComparison_WLRC-LC_1.5dd38159.jpg";